import {createSlice} from "@reduxjs/toolkit";

const tokenCheckup = localStorage.getItem('loginStatus');

const initalState = {
  'userdetails':{},
  'access_token':'',
  'isLoggedIn': !!tokenCheckup,
}

const authSlice = createSlice({
  'name' : 'auth',
  'initialState': initalState,
  reducers:{
    login : (state,action) => {
      state.userdetails = action.payload.userdetails
      state.access_token = action.payload.access_token
      state.isLoggedIn = true
      localStorage.setItem('userdetails',JSON.stringify(state.userdetails))
      localStorage.setItem('access_token',state.access_token)
      localStorage.setItem('loginStatus',true)
    },
    logout : (state) => {
      state.userdetails = null
      state.access_token = ''
      state.isLoggedIn = false
      localStorage.removeItem('userdetails')
      localStorage.removeItem('access_token')
      localStorage.removeItem('loginStatus')
    }
  }
})

export const {login,logout} = authSlice.actions;

export default authSlice.reducer